import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import Recruit from '../../entities/booking/recruit';

interface RecruitState extends ListState<Recruit>{
    editRecruit:Recruit
}
class RecruitMutations extends ListMutations<Recruit>{

}
class RecruitModule extends ListModule<RecruitState,any,Recruit>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Recruit>(),
        loading:false,
        editRecruit:new Recruit()
    }
    actions={
        async getAll(context:ActionContext<RecruitState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Recruit/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Recruit>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getMyRecruits(context:ActionContext<RecruitState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Recruit/GetMyRecruits',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Recruit>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<RecruitState,any>,payload:any){
            await Ajax.post('/api/services/app/Recruit/Create',payload.data);
        },
        async update(context:ActionContext<RecruitState,any>,payload:any){
            await Ajax.put('/api/services/app/Recruit/Update',payload.data);
        },
        async delete(context:ActionContext<RecruitState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/Recruit/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<RecruitState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Recruit/Get?Id='+payload.id);
            return reponse.data.result as Recruit;
        }
    };
    mutations={
        setCurrentPage(state:RecruitState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:RecruitState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:RecruitState,recruit:Recruit){
            state.editRecruit=recruit;
        }
    }
}
const recruitModule=new RecruitModule();
export default recruitModule;